"use client";

import React, { useState } from 'react';
import { Offer, ProductData } from '@/services/dataTypes';
import { getFinalDiscountTag } from '@/constants/hooks';
import Link from 'next/link';
import SimpleOfferModal from './SimpleOfferModal';

interface Props {
    offer: Offer | ProductData;
    merchantHref: string;
    imageSrc: string;
    merchantImg?: string | null;
    domain: string;
    type: 'anchor' | 'button';
    buttonClass?: string;
    isDetail?: number;
    productDetailUrl?: string | null;
}

const OfferDetailsToggle = ({ offer, merchantHref, domain, type, buttonClass, imageSrc, isDetail, productDetailUrl, merchantImg }: Props) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    const originalPrice = offer?.original_price ? parseFloat(offer.original_price) : 0;
    const salePrice = offer?.sale_price ? parseFloat(offer.sale_price) : 0;
    const discountPercent = originalPrice > 0 && salePrice > 0
        ? Math.round(((originalPrice - salePrice) / originalPrice) * 100) : null;
    const finalDiscountTag = getFinalDiscountTag(offer?.offer_title || offer?.offer_detail, discountPercent);

    // If detail page available, link directly
    if (isDetail === 1 && productDetailUrl) {
        return (
            <Link
                href={productDetailUrl}
                className="text-[10px] font-black uppercase tracking-widest no-underline transition-colors duration-200 hover:text-[#7AFC20]"
                style={{ color: 'rgba(8,28,17,0.45)' }}
            >
                View Details
            </Link>
        );
    }

    const sharedClass = `text-[10px] font-black uppercase tracking-widest cursor-pointer transition-colors duration-200 hover:text-[#7AFC20] ${buttonClass || ''}`;
    const sharedStyle = buttonClass ? undefined : { color: 'rgba(8,28,17,0.45)' };

    return (
        <>
            {type === 'anchor' ? (
                <span
                    onClick={handleClick}
                    className={sharedClass}
                    style={sharedStyle}
                >
                    View Details
                </span>
            ) : (
                <button
                    onClick={handleClick}
                    className={sharedClass}
                    style={sharedStyle}
                >
                    View Details
                </button>
            )}

            {showModal && (
                <SimpleOfferModal
                    data={offer}
                    onClose={() => setShowModal(false)}
                    domain={domain}
                    finalDiscountTag={finalDiscountTag}
                    merchantHref={merchantHref}
                    merchantImg={merchantImg}
                    productImg={imageSrc}
                />
            )}
        </>
    );
};

export default OfferDetailsToggle;
